export default __webpack_public_path__ + "static/media/nutritionfood.12c85014.svg";